import update from 'immutability-helper';
import * as types from './types';
import { CREATE_NEW_SPI_CONFIG } from '@src/utils/kpi';

const initialState = {
  isInitializing: true,
  thresholds: [],
  selectedConfig: {},
  isBeingEdited: false,
  isCreateNewSelected: false,
  isFetching: true,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_SPI_THRESHOLD] = (state, action) => {
  return update(state, {
    thresholds: {
      $set: action.config,
    },
  });
};

switchMap[types.SET_SELECTED_CONFIG] = (state, action) => {
  // const selectedConfig = setSelected(action.payload.kpiId, state);
  return update(state, {
    selectedConfig: {
      $set: action.payload,
    },
  });
};

switchMap[types.SET_FETCHING] = (state, action) => {
  const { isFetching } = action;
  return update(state, {
    $merge: {
      isFetching,
    },
  });
};

switchMap[types.SET_INITIALIZING] = (state, action) => {
  const { isInitializing } = action;
  return update(state, {
    $merge: {
      isInitializing,
    },
  });
};

switchMap[types.SET_ERROR] = (state, action) => {
  const { errorCode, errorMsg } = action;
  return update(state, {
    $merge: {
      errorCode,
      errorMsg,
      invalid: false,
    },
  });
};

switchMap[types.UPDATE_SELECTED_CONFIG] = (state, action) =>
  update(state, {
    selectedConfig: {
      [action.payload.key]: { $set: action.payload.value },
    },
  });

switchMap[types.SELECT_CREATE_NEW] = (state, action) =>
  update(state, {
    isCreateNewSelected: { $set: action.flag },
  });

switchMap[types.SET_EDITABLE_FLAG] = (state, action) =>
  update(state, {
    isBeingEdited: { $set: action.flag },
  });

const setSelected = (kpiId, state) => {
  let selected = {};
  if (kpiId) {
    state.thresholds.forEach((item: any) => {
      if (item.kpiID === kpiId) {
        selected = item;
      }
    });

    return selected;
  }
  return CREATE_NEW_SPI_CONFIG;
};

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
